<template>
  <div v-if="items && items.length" wrap fill style="gap: 10px; padding-top: 5px; align-content: flex-start">
    <div v-for="(item, index) in items" :key="index" style="width: auto">
      <div v-if="item.label?.length" class="field-label">
        {{ item.label }}<span v-if="isRequired(item)" style="color: var(--error); margin-left: 2px">*</span
        ><span class="type-tag">{{ item.type }}</span>
      </div>
      <v-text-field
        v-if="item.type == 'STRING' || item.type == 'NUMBER'"
        :disabled="disabled"
        :type="item.type"
        hide-spin-buttons
        dense
        hide-details
        :style="{ width: Math.min(Math.max((item.value || '').length * 10, 160), 400) + 'px' }"
        :value="item.value"
        @input="updateField(index, 'value', $event)"
        clearable></v-text-field>

      <DatePickerComponent
        v-if="item.type == 'DATE'"
        :value="item.dateValue"
        :disabled="disabled"
        @change="setDate(index, $event)"
        style="width: 100%"></DatePickerComponent>

      <v-select
        v-if="item.type == 'DROPDOWN'"
        attach
        dense
        style="width: 100%"
        :items="item.allowedValues"
        :value="item.value"
        :disabled="disabled"
        @change="updateField(index, 'value', $event)"></v-select>

      <v-select
        v-if="item.type == 'MULTISELECT'"
        attach
        dense
        multiple
        small-chips
        deletable-chips
        style="width: 100%; min-width: 260px"
        :disabled="disabled"
        :items="item.allowedValues"
        :value="item.arrayValue"
        @change="updateField(index, 'arrayValue', $event)"></v-select>

      <v-combobox
        v-if="item.type == 'TAG'"
        chips
        append-icon=""
        auto-grow
        hide-details
        small-chips
        deletable-chips
        multiple
        style="width: 100%"
        :disabled="disabled"
        :value="item.arrayValue"
        @change="updateField(index, 'arrayValue', $event)"></v-combobox>

      <v-textarea
        v-if="item.type == 'NOTE'"
        rows="1"
        auto-grow
        :disabled="disabled"
        :value="item.value"
        @input="updateField(index, 'value', $event)"
        style="width: 100%"></v-textarea>

      <div
        v-if="item.type == 'CHECKBOX'"
        button
        :disabled="disabled"
        @click="toggleCheckbox(index)"
        style="width: 56px !important; height: auto; min-height: 28px; margin-top: 4px">
        <v-icon button :class="{ 'is-on': !!item.booleanValue }" size="24">mdi-check-bold</v-icon>
        <v-icon button :class="{ 'is-on': !item.booleanValue }" size="24">mdi-close-thick</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Edited in place: the owner keeps the list and decides what a change means.
    items: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    // Ids of fields the owner marks with a *; the owner also decides what to do about them.
    required: { type: Array, default: () => [] },
  },
  methods: {
    isRequired(item) {
      return this.required.indexOf(item.id) !== -1;
    },
    // $set, because a field straight out of a metadata set has no value key yet.
    updateField(index, key, value) {
      this.$set(this.items[index], key, value);
      this.$emit("change");
    },
    setDate(index, event) {
      this.$set(this.items[index], "dateValue", new Date(event).toISOString());
      this.updateField(index, "value", event);
    },
    // A div ignores :disabled, so the edit check has to happen here.
    toggleCheckbox(index) {
      if (this.disabled) return;
      this.updateField(index, "booleanValue", !this.items[index].booleanValue);
    },
  },
};
</script>

<style scoped></style>
